import React, {Component} from 'react';
import styles from './styles.css';

export default class InlineCode extends Component {
	render() {
		const {isTiny, children, className} = this.props;
		const classes = [];
		classes.push(styles['inline-code']);

		if (isTiny) {
			classes.push(styles['inline-code_tiny']);
		}

		if (className) {
			classes.push(className);
		}

		return (
			<span className={classes.join(' ')}
				onClick={(e) => {
					if (window.getSelection) {
						window.getSelection().selectAllChildren(e.target);
					}
					else { // старый IE
						const range = document.selection.createRange();
						range.moveToElementText(e.target);
						range.select();
					}
				}}>
				{children}
			</span>
		);
	}
}